export const HEX_COLOR_PATTERN = /^#[\da-f]{6}$/i;
export const SPLASH_APPEARANCE_STORAGE_KEY = 'easypdv.splash-appearance';
export const DEFAULT_SPLASH_ANIMATION = '/media/animations/easypdv-splash.json';
